import { Cookies } from "sb-helpers";
import { tokenParser } from "../tokenParser";
const JWT_COOKIE_NAME = "jwtToken";
export class CookiesStorage {
    constructor(cookieManager) {
        this.cookies = cookieManager || Cookies;
    }
    clearToken() {
        this.cookies.remove(JWT_COOKIE_NAME);
    }
    setToken(value) {
        let parsedToken = tokenParser(value);
        if (parsedToken) {
            let expirationDate = new Date(parsedToken.exp * 1000);
            this.cookies.set(JWT_COOKIE_NAME, value, { expires: expirationDate });
        }
    }
    getToken() {
        return this.cookies.get(JWT_COOKIE_NAME);
    }
}
export const CookieStorage = new CookiesStorage();
//# sourceMappingURL=CookiesStorage.js.map